import script from "./PurchaseRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseRecord.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseRecord.vue?vue&type=style&index=0&id=70c8bc37&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c8bc37"]])

export default __exports__